export default __webpack_public_path__ + "static/media/logo.3b7fbea6.png";